// src/components/prospect-suspect/ProspectContextMenu.tsx
import { AssignmentTurnedIn as AssignIcon } from "@mui/icons-material";
import { MenuItem } from "@mui/material";
import React from "react";
import { MyCustomerApiResponse } from "../../../store/services/customerService";
import BaseContextMenu, { BaseAction } from "./BaseContextMenu";

// Prospect-specific actions that extend the base actions
export type ProspectAction =
  | BaseAction
  | "markAsLead"
  | "convertToCustomer"
  | "assignToSalesRep";

interface ProspectContextMenuProps {
  contextMenu: {
    mouseX: number;
    mouseY: number;
    customer: MyCustomerApiResponse;
  } | null;
  onClose: () => void;
  onAction: (action: ProspectAction) => void;
}

const ProspectContextMenu: React.FC<ProspectContextMenuProps> = ({
  contextMenu,
  onClose,
  onAction,
}) => {
  // Handle Prospect-specific actions and dialogs here
  // const [showAssignDialog, setShowAssignDialog] = useState(false);

  // Prospect-specific menu items to extend the base menu
  const prospectMenuItems = (
    <MenuItem onClick={() => onAction("assignToSalesRep")}>
      <AssignIcon fontSize="small" sx={{ mr: 1 }} />
      Tilldela säljare
    </MenuItem>
  );

  // Handle action from base menu
  const handleBaseAction = (action: BaseAction | string) => {
    onAction(action as ProspectAction);
  };

  return (
    <>
      {/* Use the BaseContextMenu with prospect-specific extensions */}
      <BaseContextMenu
        contextMenu={contextMenu}
        onClose={onClose}
        onAction={handleBaseAction}
        additionalMenuItems={prospectMenuItems}
      />

      {/* Add any prospect-specific dialogs here */}
      {/* For example, a dialog to assign prospects to sales reps */}
    </>
  );
};

export default ProspectContextMenu;
